import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "estate-listing__item" }
const _hoisted_2 = { class: "estate-card estate-card--simple" }
const _hoisted_3 = { class: "estate-card__body" }
const _hoisted_4 = { class: "estate-card__header" }
const _hoisted_5 = { class: "estate-card__title" }
const _hoisted_6 = { class: "estate-card__params" }
const _hoisted_7 = {
  key: 0,
  class: "estate-card__toolbar"
}
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "checkbox-switch" }
const _hoisted_10 = ["checked", "disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_12 = { class: "check-label" }
const _hoisted_13 = { class: "estate-card__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdParams = _resolveComponent("AdParams")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.ad.title), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["estate-card__subtitle", { 'text-success': !_ctx.ad.isSold && !_ctx.ad.isReserved, 'text-warning': _ctx.ad.isReserved, 'text-danger': _ctx.ad.isSold }])
          }, _toDisplayString(_ctx.ad.statusTitle), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AdParams, { ad: _ctx.ad }, null, 8, ["ad"])
        ]),
        _createVNode(_component_AdListItemPrice, {
          ad: _ctx.ad,
          showPriceSquare: true
        }, null, 8, ["ad"]),
        (!_ctx.isPublic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.ad.isPublished,
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                    disabled: _ctx.ad.isArchived
                  }, null, 40, _hoisted_10),
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, [
                    (_ctx.ad.isPublished)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.published')), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.unpublished')), 1)
                        ], 64))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.isPublic)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: _normalizeClass(["button button--primary", { disabled: _ctx.currentAdId === _ctx.ad.adId }]),
                to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.adFrontId } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectListItem.button-detail')), 1)
                ]),
                _: 1
              }, 8, ["to", "class"]))
            : _createCommentVNode("", true),
          (!_ctx.isPublic)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "button button--primary",
                to: { name: 'AdFormEdit', params: { adFrontId: _ctx.ad.adFrontId } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectListItem.button-edit')), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}